import * as React from 'react'
import {inject, observer} from 'mobx-react'
import {reaction} from 'mobx'
import {ScrollBehavior, ViewConfig, withRoute, RouteProps} from '@eda.yandex/web-router'
import {RouterEnv} from 'admin/types'
import {PageHeader, Select, Form, DatePicker, TimePicker, Icon, Button, Row, Col} from 'antd'
import {FormComponentProps} from 'antd/lib/form'
import {compose} from 'recompose'
import {createStyles} from '@eda.yandex/ui-kit/lib/jss'
import injectSheet, {WithClasses} from '@eda.yandex/ui-kit/lib/hocs/inject-sheet'
import {StoreType} from 'admin/models/Store'
import {DEFAULT_REGION} from 'admin/models/ctt/ShiftsTotalReportPage'
import moment, {Moment, unitOfTime} from 'moment'
import withDisposer, {WithDisposerProps} from '@eda.yandex/ui-kit/lib/hocs/disposer'
import * as qs from 'query-string'
import ShiftsReport from './report'

type Params = {
  from?: string
}
type OuterProps = {}
export type InnerProps = OuterProps & WithClasses<typeof styles> & WithDisposerProps & RouteProps & {
  store: StoreType
} & FormComponentProps

const COMPONENT_NAME = 'ShiftsTotalReportPage'
const TIME_FORMAT = 'HH:mm:ss'

const styles = createStyles({
  root: {
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column'
  },
  form: {
    marginTop: 20,
    '& input, & .ant-form-item-control-wrapper, & .ant-time-picker': {
      minWidth: 200
    }
  },
  regionSelect: {
    width: 'calc(100% - 22px) !important'
  },
  regionClear: {
    paddingLeft: 8,
    cursor: 'pointer'
  },
  showButton: {
    width: '100%',
    height: 35
  }
})

const filterOption = (inputValue: string, option: React.ReactElement) => (
  !inputValue || (option.props.children as string).toLowerCase().indexOf(inputValue.toLowerCase()) === 0
)
const setTimeToMoment = (date: Moment, time: Moment) => {
  const fields: unitOfTime.All[] = ['hours', 'minutes', 'seconds']

  date.startOf('day')
  fields.forEach((field) => {
    date.set(field, time.get(field))
  })

  return date
}

class ShiftsTotalReportPage extends React.Component<InnerProps> {
  onSubmit: React.FormEventHandler = (e) => {
    e.preventDefault()

    const {store, form} = this.props
    const {getFieldValue} = form

    const region = getFieldValue('region')
    const zone = region !== DEFAULT_REGION && getFieldValue('zone') || null
    const date = (getFieldValue('date')).startOf('day')
    const from = getFieldValue('timeFrom')
    const to = getFieldValue('timeTo')

    store.ctt.shiftsTotalReportPage.initialize({
      region,
      zone,
      from: setTimeToMoment(moment(date), from).valueOf(),
      to: setTimeToMoment(moment(date), to).valueOf()
    })
  }

  onRegionChange = (newRegionId: number) => {
    this.onZoneClear()
    this.props.store.ctt.loadRegionZones(String(newRegionId))
  }

  onZoneClear = () => {
    const {setFieldsValue} = this.props.form

    setFieldsValue({
      zone: undefined
    })
  }

  resetForm = () => {
    this.props.store.ctt.shiftsTotalReportPage.resetForm()
    this.props.form.resetFields()
  }

  componentDidMount () {
    const {store} = this.props

    this.props.withDisposer([
      reaction(
        () => store.ctt.shiftsTotalReportPage.pageUrlParams,
        (urlParams) => {
          this.props.routeManager.history.replace('/ctt/shift-totals-report?' + String(qs.stringify(urlParams)))
        },
        {fireImmediately: true}
      )
    ])
  }

  renderForm () {
    const {getFieldDecorator, getFieldValue} = this.props.form
    const {classes: c} = this.props
    const {store} = this.props
    const {regions, shiftsTotalReportPage} = store.ctt
    const formState = shiftsTotalReportPage.state
    const formItemLayout = {
      labelCol: {span: 24},
      wrapperCol: {span: 4}
    }
    const colItemLayout = {
      span: 8
    }
    const colButtonLayout = {
      span: 24
    }
    const regionValue = getFieldValue('region')
    const region = regionValue !== DEFAULT_REGION && store.ctt.getRegionById(regionValue)
    const initialRegionValue = formState.region
    const initialZoneValue = formState.zone
    const initialDateValue = moment(formState.from)
    const initialTimeFromValue = moment(formState.from)
    const initialTimeToValue = moment(formState.to)

    const zonesToRender = region ?
      region.zones
        .filter((zone) => zone.status === 'active')
      : []

    return (
      <Form {...formItemLayout} onSubmit={this.onSubmit} className={c.form}>
        <Row>
          <Col {...colItemLayout} >
            <Form.Item label='Регион'>
              {getFieldDecorator('region', {
                initialValue: initialRegionValue,
                rules: [{
                  required: true, message: 'Регион обязательный'
                }]
              })(
                <Select
                  showSearch
                  placeholder='Выберите регион'
                  optionFilterProp='name'
                  filterOption={filterOption}
                  onChange={this.onRegionChange}
                >
                  {
                    regions.map((r) => (
                      <Select.Option value={r.id} key={r.id}>{r.name}</Select.Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
          </Col>
          {
            regionValue !== DEFAULT_REGION ? (
              <Col {...colItemLayout} >
                <Form.Item label='Зона'>
                  {getFieldDecorator('zone', {
                    initialValue: initialZoneValue
                  })(
                    <Select
                      showSearch
                      placeholder='Выберите зону'
                      filterOption={filterOption}
                      className={getFieldValue('zone') ? c.regionSelect : undefined}
                    >
                      {
                        zonesToRender
                          .map((z) => (
                          <Select.Option value={z.id} key={z.id}>{z.name}</Select.Option>
                        ))
                      }
                    </Select>
                  )}
                  {
                    getFieldValue('zone') ?
                      <Icon type='close-square' theme='filled' onClick={this.onZoneClear} className={c.regionClear} />
                      : null
                  }
                </Form.Item>
                </Col>
            ) : null
          }
          <Col {...colItemLayout} >
            <Form.Item label='Дата смены'>
              {getFieldDecorator('date', {
                initialValue: initialDateValue,
                rules: [{
                  required: true
                }]
              })(
                <DatePicker
                  allowClear={false}
                  placeholder='Выберите дату'
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col {...colItemLayout} >
            <Form.Item label='Начало смены'>
              {getFieldDecorator('timeFrom', {
                initialValue: initialTimeFromValue,
                rules: [{
                  required: true
                }]
              })(
                <TimePicker
                  allowClear={false}
                  format={TIME_FORMAT}
                  placeholder='Выберите время'
                />
              )}
            </Form.Item>
          </Col>
          <Col {...colItemLayout} >
            <Form.Item label='Конец смены'>
              {getFieldDecorator('timeTo', {
                initialValue: initialTimeToValue,
                rules: [{
                  required: true
                }]
              })(
                <TimePicker
                  allowClear={false}
                  format={TIME_FORMAT}
                  placeholder='Выберите время'
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col {...colButtonLayout} >
            <Form.Item>
              <Button
                type='primary'
                htmlType='submit'
                loading={shiftsTotalReportPage.pending}
                className={c.showButton}
              >
                Показать
              </Button>
            </Form.Item>
          </Col>
          <Col {...colButtonLayout} >
            <Form.Item>
              <Button
                type='dashed'
                className={c.showButton}
                onClick={this.resetForm}
              >
                Сбросить
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }

  render () {
    const {classes: c} = this.props

    return (
      <div className={c.root}>
        <PageHeader title='Резюме графика курьеров'>
          {this.renderForm()}
        </PageHeader>
        <ShiftsReport />
      </div>
    )
  }
}

const EnhancedShiftsTotalReportPage = compose<InnerProps, OuterProps>(
  Form.create({name: 'register'}),
  injectSheet(styles, COMPONENT_NAME),
  inject('store'),
  withDisposer,
  withRoute,
  observer
)(ShiftsTotalReportPage)

const viewConfig: ViewConfig<RouterEnv, Params> = {
  async controller (routeUnit, env) {
    const result = await env.store.ctt.shiftsTotalReportPage.initializeFromUrlParams(routeUnit.params)
    if (result === false) {
      return {
        scroll: ScrollBehavior.Prevent
      }
    }

    return undefined
  },
  displayName: COMPONENT_NAME,
  Component: EnhancedShiftsTotalReportPage
}

export default viewConfig
